// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_es-3";
export var flatBottomCorners = "_es-5";
export var productImage = "_es-0";
export var quantityContainer = "_es-2";
export var quantityHeader = "_es-6";
export var tooltip = "_es-1";
export var wrapAndEllipsesOverflow = "_es-4";